// extracted by mini-css-extract-plugin
export default {"content":"AddArticle_content__5MSrh","realContent":"AddArticle_realContent__nIGkf"};